import apiClient from "../apiClient";

let ControllerName = "blog";
// const BlogController = Object.freeze({
//     allBlogs: `${ControllerName}`,
// });

/*
 * Fetch all blogs from the server.
 *
 * @returns {Promise<Object[]>} A promise that resolves to the array of blogs if the request is successful.
 */
export const getBlogs = async (perPage = 10) => {
  try {
    const response = await apiClient.get(`${ControllerName}`, {
      params: { per_page: perPage },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching blogs:', error);
  }
};

/*
 * Fetch the details of a single blog based on its slug.
 * This function makes an API call to retrieve detailed information about a specific blog.
 *
 * @param {string} blogSlug - The unique identifier (slug) of the blog to be fetched.
 * @returns {Promise<Object>} A promise that resolves to the details of the blog if the request is successful.
 *
 */
export const getblogContent = async (blogSlug) => {
  try {
    const response = await apiClient.get(`${ControllerName}/${blogSlug}`);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
